module.exports = __webpack_public_path__ + "img/add_wallet.ce61f4d5.svg";